import { render, staticRenderFns } from "./Footer-view.vue?vue&type=template&id=44bd166e&scoped=true"
import script from "./Footer-view.vue?vue&type=script&lang=js"
export * from "./Footer-view.vue?vue&type=script&lang=js"
import style0 from "./Footer-view.vue?vue&type=style&index=0&id=44bd166e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd166e",
  null
  
)

export default component.exports